/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope). */

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 168px;
  height: 100%;
  padding: 16px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.monogram {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.footer {
  padding-top: 10px;
  border-top: 1px solid var(--color-border);
}

/* Monogram category colors — Astryx tokens, active inside the theme scope */
.mono_blue {
  background: var(--color-background-blue);
  color: var(--color-text-blue);
}
.mono_green {
  background: var(--color-background-green);
  color: var(--color-text-green);
}
.mono_purple {
  background: var(--color-background-purple);
  color: var(--color-text-purple);
}
.mono_teal {
  background: var(--color-background-teal);
  color: var(--color-text-teal);
}
.mono_pink {
  background: var(--color-background-pink);
  color: var(--color-text-pink);
}
.mono_orange {
  background: var(--color-background-orange);
  color: var(--color-text-orange);
}
